module.exports = __webpack_public_path__ + "img/air-conditioner.664bf1b0.svg";